import http from '../utils/fetch'

export default {
  getProductDetail (serialId) {
    return http.get({url: `products/${serialId}`})
  },
  getProductReviews (serialId, cb, errorCb) {
    http.get({url: `products/${serialId}/reviews`})
      .then((res) => {
        cb(res)
      }, (res) => {
        errorCb(res)
      })
  },
  getReviewTags (serialId) {
    return http.get({url: `products/${serialId}/reviewTags`})
  },
  getProductFaqs (serialId, cb, errorCb) {
    http.get({url: `products/${serialId}/faq`})
      .then((res) => {
        cb(res)
      }, (res) => {
        errorCb(res)
      })
  },
  getProductList (regionCode, category) {
    return http.get({url: `products?regionCode=${regionCode}&classificationName=${category}`})
  },
  searchProductList (regionCode, keyword) {
    return http.get({url: `products/search?regionCode=${regionCode}&keyword=${keyword}`})
  },
  getNavList (regionCode) {
    // debugger
    return http.get({url: `products?regionCode=${regionCode}`})
  },
  sendReview (review) {
    return http.post({
      url: "reviews/",
      data: review
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/product.js